import { Button } from './button';
import { Dialog, DialogTitle, DialogBody, DialogActions } from './dialog';

interface SendItConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function SendItConfirmationDialog({
  open,
  onClose,
  onConfirm,
}: SendItConfirmationDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Opportunity Creation</DialogTitle>
      <DialogBody>
        <p className="tw:text-zinc-900 tw:dark:text-zinc-100">
          Changing the Labor Tier to &quot;Sendit Marketplace&quot; will automatically create an
          Opportunity in Draft status for you to refine and post live to Sendit&apos;s physician
          marketplace. Click Confirm to proceed.
        </p>
      </DialogBody>
      <DialogActions>
        <Button type="button" outline onClick={onClose}>
          Cancel
        </Button>
        <Button type="button" color="brandgreen0" onClick={onConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
